import React from 'react';

import styled from 'styled-components';

import IconSodium from 'components/icons/sodium-flag';
import { useLocale } from 'state/intl';

const StyledSodiumFlag = styled(IconSodium)`
  height: 20px;
  margin-bottom: -0.2rem;
  margin-left: 0.2rem;
  fill: ${Styles.color.black};
`;

const SodiumFlag = () => {
  const { region } = useLocale();

  if (region !== 'US') {
    return null;
  }

  return <StyledSodiumFlag data-testid="sodium-flag" />;
};

export default SodiumFlag;
